import { IonInput } from "@ionic/react";
import React from "react";
import { Control, Controller, FieldErrors, UseFormWatch } from "react-hook-form";
import CommonFormElement from "../UI/CommonFormElements/CommonFormElement";
import { AddressInput } from "@core/types";
import classNames from "classnames/bind";
import commonFormStyles from "../UI/CommonFormElements/CommonFormElements.module.scss";
import styles from "./AddressForm.module.scss";
import { useTranslation } from "react-i18next";

interface ApartmentDetailsProps {
  control: Control<AddressInput>;
  errors: FieldErrors<AddressInput>;
  watch: UseFormWatch<AddressInput>;
}

const cx = classNames.bind(styles);

const commonForm = classNames.bind(commonFormStyles);

const ApartmentDetails = ({ control, errors, watch }: ApartmentDetailsProps) => {
  const { t } = useTranslation();
  return (
    <div className={cx("dropdown", { dropdown__active: !!watch("isFlat") })}>
      {!!watch("isFlat") && (
        <>
          <Controller
            control={control}
            name="entrance"
            rules={{
              required: t("Required field"),
            }}
            render={({ field: { onChange, value } }) => (
              <>
                <CommonFormElement
                  isRequired
                  label={t("Entrance")}
                  isValid={!!value}
                  errorMessage={errors.entrance?.message}
                >
                  <IonInput
                    type="text"
                    value={value}
                    onIonChange={(e) => onChange(e.detail.value!)}
                    placeholder={t("Entrance input placeholder")}
                    className={commonForm("commonElement", { commonInvalid: !watch("entrance")?.length })}
                  />
                </CommonFormElement>
              </>
            )}
          />
          <Controller
            control={control}
            name="intercom"
            render={({ field: { onChange, value } }) => (
              <>
                <CommonFormElement label={`${t("Intercom code")}  (${t("optional")})`}>
                  <IonInput
                    type="text"
                    value={value}
                    onIonChange={(e) => onChange(e.detail.value!)}
                    placeholder={t("Intercom input placeholder")}
                    className={commonForm("commonElement")}
                  />
                </CommonFormElement>
              </>
            )}
          />
          <Controller
            control={control}
            name="floor"
            rules={{
              required: t("Required field"),
            }}
            render={({ field: { onChange, value } }) => (
              <>
                <CommonFormElement
                  isRequired
                  label={t("Floor")}
                  errorMessage={errors.floor?.message}
                  isValid={!!value}
                >
                  <IonInput
                    type="text"
                    value={value}
                    onIonChange={(e) => onChange(e.detail.value!)}
                    placeholder={t("Floor input placeholder")}
                    className={commonForm("commonElement", { commonInvalid: !watch("floor")?.length })}
                  />
                </CommonFormElement>
              </>
            )}
          />
          <Controller
            control={control}
            name="apartmentNumber"
            rules={{
                required: t("Required field"),
            }}
            render={({ field: { onChange, value } }) => (
              <>
                <CommonFormElement
                  isRequired
                  label={t("Apartment number")}
                  isValid={!!value}
                  errorMessage={errors.apartmentNumber?.message}
                >
                  <IonInput
                    type="text"
                    value={value}
                    onIonChange={(e) => onChange(e.detail.value!)}
                    placeholder={t("Apartment input number placeholder")}
                    className={commonForm("commonElement", { commonInvalid: !watch("apartmentNumber")?.length })}
                  />
                </CommonFormElement>
              </>
            )}
          />
        </>
      )}
    </div>
  );
};

export default ApartmentDetails;
